export default "__VITE_ASSET__Be$1bUQb__"